module.exports = __webpack_public_path__ + "img/plug-3.84fe54a.png?v=1791296779994";